import React, { Component } from 'react';
import { inject } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

import moment from 'moment';

import { Section } from '../shared';
import Iframe from './Iframe';
import Header from './Header';
import Arrow from './Arrow';

const styles = ({ palette }) => ({
  root: {
    position: 'relative',
    '& .container': {
      maxWidth: '1080px',
      position: 'relative',
      padding: 0,
      border: 'none',
      backgroundColor: 'transparent',
    },
    '& .call-to-action': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'absolute',
      top: 0,
      height: '100%',
      width: '100%',
    },
    '& a': {
      padding: '0.5em 1em',
    },
    '& img': {
      width: '100%',
      height: 'auto',
      position: 'relative',
    },
  },
});

const mapper = (stores, props) => ({
  intl: stores.intl.dictionary,

  report: (e) => stores.analytics.report(e),

  /** post message events */
  score: ({ score }) => stores.ranking.score(score),
  share: ({ platform, score }) => stores.social.share(platform, score),
  register: (ev) => {
    return stores.analytics.event(
      Object.assign(
        {
          category: 'Game',
          action: 'Play',
        },
        ev
      )
    );
  },
  updateRanking: () => stores.ranking.fetchRanking(),
  // setFullscreen: (fullscreen) => stores.ui.setFullscreen(fullscreen),
});

class Game extends Component {
  state = {
    height: window.screen.height,
  };
  componentWillMount() {
    this._handleResize();
    window.addEventListener('resize', this._handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this._handleResize);
  }

  render() {
    const { classes, intl } = this.props;
    const timestamp = moment().format('YYMM');
    return (
      <React.Fragment>
        <Section className={classes.root} id="sesion-juego">
          <Header />
          <img
            src={`./static/images/game/arcade.png?${timestamp}`}
            alt={intl['LOCALE.FLIPERAMA']}
            title={intl['LOCALE.FLIPERAMA']}
          />
          <div className={classNames('call-to-action')}>
            <Iframe handleReceiveMessage={this._onMessage} />
          </div>
          <Arrow />
        </Section>
      </React.Fragment>
    );
  }

  _onMessage = async (event) => {
    let { data } = event;
    const fn = this.props[data.fnName];

    if (data.params && data.params[0] && typeof data.params[0] === 'string') {
      data.params = JSON.parse(data.params[0]);
    }

    if (!fn) return;

    try {
      fn && (await fn(data.params));
      event.stopPropagation();
    } catch (e) {
      this.props.report(e);
    }
  };

  _handleResize = () => {
    this._handleBoxHeight();
  };

  _handleBoxHeight() {
    let {
      screen: { width, height },
    } = window;
    if (width > 1080) width = 1080;
    height = (width * 9) / 16;
    this.setState({ height });
  }
}

export default inject(mapper)(withStyles(styles)(Game));
